import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as ContactSVG } from "../../../assets/images/icon-contact.svg";
import Styles from "../../../scss/orderDetails.module.scss";
import { IProcessedOrdersDetails, PreferredContact } from "../constants";

interface ICustomerDetailsProps {
    orderDetails: IProcessedOrdersDetails;
}

export function CustomerDetails({
    orderDetails
}: ICustomerDetailsProps) {
    const { t } = useTranslation();
    if (!orderDetails) return null;

    const { consumer, placed_order } = orderDetails;
    return <div className={Styles.UserDetailsSection}>
        <div>
            <div>
                <p className={Styles.label}>{t("orderHistory.modal.customerInfo")}</p>
                <p>{t("orderHistory.modal.PreferredContact",{preferred:consumer.consumer_contact_preference===PreferredContact.Email?"Email":"SMS"})}</p>
            </div>
            <div>
                <ContactSVG />
                <div>
                    <p>{consumer.consumer_first_name} {consumer.consumer_last_name}</p>
                    <p><span>{consumer.consumer_contact_phone && consumer.consumer_contact_phone}</span>
                        <span>{consumer.consumer_contact_email && consumer.consumer_contact_email}</span></p>
                </div>
            </div>
        </div>
        {placed_order.placed_order_customer_note && <div style={{ marginTop: "1.625rem" }}>
            <div>
                <p className={Styles.label}>{t("orderHistory.modal.customerNote")}</p>
            </div>
            <div>
                <p>{placed_order.placed_order_customer_note}</p>
            </div>
        </div>}
    </div>
}